import { render, staticRenderFns } from "./ScreenConfigurePresenceDetectors.vue?vue&type=template&id=60529994&scoped=true&"
import script from "./ScreenConfigurePresenceDetectors.vue?vue&type=script&lang=js&"
export * from "./ScreenConfigurePresenceDetectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60529994",
  null
  
)

export default component.exports